import { SelecaoAcessorioPropostaValidador } from '@/features/proposta/entities/ListarProdutosProposta/selecao-acessorio-proposta-validador'
import type { SelecaoProdutoPropostaValidadorBase } from '@/features/proposta/entities/ListarProdutosProposta/selecao-produto-proposta-validador-base'
import { SelecaoUnidadePropostaValidador } from '@/features/proposta/entities/ListarProdutosProposta/selecao-unidade-proposta-validador'
import type { TGetSimulacoesRelacionadas } from '@/shared/interfaces'

type TSelecaoProdutoPropostaFactory = {
  simulacoes: TGetSimulacoesRelacionadas['relacionadas']
  simulacaoSelecionada: TGetSimulacoesRelacionadas['relacionadas'][number]
  tipoProdutoSimulacaoDoSimulador: TGetSimulacoesRelacionadas['simulacaoPrincipal']['tipoDoProduto']
}

export class SelecaoProdutoPropostaFactory {
  static create({
    tipoProdutoSimulacaoDoSimulador,
    simulacoes,
    simulacaoSelecionada,
  }: TSelecaoProdutoPropostaFactory): SelecaoProdutoPropostaValidadorBase {
    switch (tipoProdutoSimulacaoDoSimulador) {
      case 'Unidade':
        return new SelecaoUnidadePropostaValidador({ simulacoes, simulacaoSelecionada })
      case 'Acessorio':
        return new SelecaoAcessorioPropostaValidador({ simulacoes, simulacaoSelecionada })
      default:
        throw new Error(`Tipo de produto desconhecido: ${tipoProdutoSimulacaoDoSimulador}`)
    }
  }
}
